import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { render } from 'react-dom';
import { ContentMarketing } from '../../../shared/types/contentMarketing';
import * as React from 'react';
import { escapeContentMarketing } from './content-marketing-container';
import { buildLinkTag, warpResources } from '../web-components/utils';
import VerticalSwitch, { Props } from './verticals';
import { PageType, Vertical } from '../../../shared/types/ast';
export const NAME = 'advt-content-marketing-switch';

@customElement(NAME)
export class ContentMarketingSwitchWebComponent extends LitElement {
    @property({ type: Object })
    contentMarketing: ContentMarketing = null;

    @property({ type: Array })
    contentMarketingList: ContentMarketing[] = null;

    @property({ type: String })
    pageType: PageType = null;

    @property({ type: String })
    vertical: Vertical = null;

    updated(_changedProperties) {
        super.updated(_changedProperties);

        const props = {
            pageType: this.pageType,
            vertical: this.vertical,
            contentMarketing: undefined,
            contentMarketingList: undefined,
        };
        if (this.contentMarketing) {
            props.contentMarketing = escapeContentMarketing(
                this.contentMarketing,
            );
            this.renderReact(props);
        } else if (
            Array.isArray(this.contentMarketingList) &&
            this.contentMarketingList.length > 0
        ) {
            props.contentMarketingList = this.contentMarketingList.map((ed) =>
                escapeContentMarketing(ed),
            );
            this.renderReact(props);
        }
    }

    renderReact(props: Props) {
        render(
            <VerticalSwitch {...props} />,
            this.shadowRoot.getElementById(`${NAME}-root`),
        );
    }

    render() {
        return html`
            <style>
                html {
                    font-size: 62.5%;
                }
            </style>
            ${warpResources.links.map(buildLinkTag)}
            <style>
                body {
                    margin: 0;
                }
                ${warpResources.fonts.map((fontDef) => html`${fontDef}`)}
            </style>

            <div id="${NAME}-root" class="advt-placement"></div>
        `;
    }
}
